import Grid, { Col } from 'src/ui/atoms/grid';
import styled from 'styled-components';
import { query } from 'ui/styles/queries';

export const CardItem = styled(Grid)`
  align-content: flex-start;
  margin-left: 0;
  margin-right: 0;
  gap: 32px;
  margin-bottom: 8px;
  min-height: 30px;

  > *:first-child {
    flex: 2 0 0%;
    padding: 0;
  }

  > *:nth-child(2) {
    flex: 3 0 0%;
    padding: 0;
  }

  ${query.phone`
    flex-direction: column;
    gap: 4px;
    margin-bottom: 16px;
  `};
`;

export const Title = styled(Col)`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.grayDark};
  overflow: hidden;
  text-overflow: ellipsis;

  ${query.phone`
    font-size: 11px;
  `};
`;

export const ContentContainer = styled(Col)`
  overflow: hidden;
`;

export const Content = styled.div`
  display: inline-flex;
  max-width: 100%;
`;

export const TruncatedText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;
